import { PropsWithChildren } from "react";

import { CobrandedProductLogo } from "../bxp-ui-signup/src/components/site-name-form/components/variants/new-user-confluence-workspace-name";

import { SignupBackgroundLayout } from "./signup-background-layout";

export interface ConfluenceSignupBackgroundLayoutProps
    extends PropsWithChildren {
    newUser?: boolean;
}

export const ConfluenceSignupBackgroundLayout = ({
    children,
    newUser = false
}: ConfluenceSignupBackgroundLayoutProps) => {
    return (
        <SignupBackgroundLayout
            ProductLogo={<CobrandedProductLogo />}
            page={
                newUser
                    ? "NEW_USER_WORKSPACE_FORM"
                    : "EXISTING_USER_WORKSPACE_FROM"
            }
        >
            {children}
        </SignupBackgroundLayout>
    );
};
